import { render, staticRenderFns } from "./CollectionAreas.vue?vue&type=template&id=fac34c7e&scoped=true&"
import script from "./CollectionAreas.vue?vue&type=script&lang=js&"
export * from "./CollectionAreas.vue?vue&type=script&lang=js&"
import style0 from "./CollectionAreas.vue?vue&type=style&index=0&id=fac34c7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac34c7e",
  null
  
)

export default component.exports